import React from 'react'
import ReactSelect from 'react-select'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import 'react-select/dist/react-select.css'
import styles from './Select.css'

export default class Select extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    options: PropTypes.array.isRequired,
    closeOnSelect: PropTypes.bool,
    required: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    type: PropTypes.oneOf(['basic', 'multi', 'floating']),
    size: PropTypes.oneOf(['small', 'medium']),
    kind: PropTypes.oneOf(['dark', 'light', 'transparent']),
    label: PropTypes.string,
    value: PropTypes.string,
  }
  static defaultProps = {
    className: null,
    closeOnSelect: true,
    required: false,
    name: null,
    onChange: null,
    placeholder: 'Select an option',
    type: 'basic',
    size: 'medium',
    kind: 'dark',
    label: null,
    value: null,
  }
  constructor(props, contenxt) {
    super(props, contenxt)
    this.state = {
      removeSelected: true,
      disabled: props.disabled,
      value: props.value,
    }
    this.handleSelectChange = this.handleSelectChange.bind(this)
  }
  handleSelectChange (v) {
    this.setState({ value: v })
    if (this.props.onChange instanceof Function) {
      this.props.onChange(v)
    }
  }

  render () {
    const {
      className,
      required,
      name,
      type,
      size,
      kind,
      label,
      closeOnSelect,
      options,
      placeholder,
    } = this.props

    const { value, disabled } = this.state

    let labelRender
    if (label) {
      labelRender = (
        <div className={styles.label}>{label}</div>
      )
    }

    const classes = classNames(
      'component-select',
      styles.select,
      className,
    )


    return (
      <div className={styles.selectWrapper}>
        {labelRender}
        <ReactSelect
          closeOnSelect={closeOnSelect}
          disabled={disabled}
          multi={type === 'multi'}
          onChange={this.handleSelectChange}
          options={options}
          placeholder={placeholder}
          removeSelected={this.state.removeSelected}
          simpleValue
          value={(value && value.length) ? value : null}
          required={required}
          name={name}
          searchable={type === 'multi'}
          className={classNames(
            className,
            styles[`type${type.charAt(0).toUpperCase() + type.slice(1)}`], // Will result in style class e.g. typeBasic
            styles[`size${size.charAt(0).toUpperCase() + size.slice(1)}`], // Will result in style class e.g. sizeSmall
            styles[`kind${kind.charAt(0).toUpperCase() + kind.slice(1)}`], // Will result in style class e.g. kindDark
          )}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/Select/Select.js